document.addEventListener('DOMContentLoaded', function() {
    if(!Swiper) return
    document.querySelectorAll(".article-blog-list__swiper").forEach(slider => {
        if (!slider.swiper && window.innerWidth <= 768) {
            const sectionSlider = new Swiper(slider, {
                slidesPerView: 1.3,
                spaceBetween: 10,
                watchSlidesProgress: true
            })
        }
    })
})